<template lang="pug">
  v-text-field(
    v-model="localModel"
    v-bind="$attrs"
    v-mask="mask"
    :rules="[() => !error || `Date invalide`]")
</template>

<script>
import { computed, ref, watch, onMounted } from '@vue/composition-api'
import { mask } from 'vue-the-mask'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

import Vue from 'vue'

export default {
  directives: {
    mask
  },

  props: {
    value: String
  },

  setup (props, { emit }) {
    const localModel = ref(``)
    const mask = `## / ## / ####`
    const error = ref(false)
    const firstValue = ref(null)

    watch(
      () => props.value,
      value => {
        if (!firstValue.value) {
          firstValue.value = props.value
        }
        const day = dayjs(value)
        if (day.isValid()) {
          localModel.value = day.format(`DD / MM / YYYY`)
        }
      }, {
        immediate: true
      }
    )

    watch(
      () => localModel.value,
      localModel => {
        if (localModel.length === mask.length) {
          /**
           * completed
           */
          const day = dayjs(localModel, `DD / MM / YYYY`, true)
          if (!day.isValid()) {
            error.value = true
          } else {
            const dayFormatted = day.format()
            emit(
              `input`,
              firstValue.value && dayjs(firstValue.value).hour(0).minute(0).second(0).format() === dayFormatted
                ? firstValue.value
                : dayFormatted
            )
          }
        } else {
          /**
           * is completing, or empty
           */
          error.value = false
          emit(`input`, null)
        }
      }
    )

    return {
      mask,
      localModel,
      error
    }
  }
}
</script>